import React from 'react';
import { ListGroup } from 'react-bootstrap';
import BrandBadge from './BrandBadge';
import SupportArticleSvg from '../images/support-article.png'

const SearchResultIntercomArticle = ({ result, ...props }) => {
  const { title, description, previewImage, url } = result.attributes

  return (
    <ListGroup.Item action {...props} href={url} className="global-search-result-item" active={false} target="_blank" rel="noopener noreferrer">
      <div className="global-search-preview-image-container text-dark">
        <img src={SupportArticleSvg} alt="Support Article" className="img-fluid" />
      </div>
      <div className="global-search-preview-details-container">
        <span className="text-dark fw-medium"> { title } </span>
        { description && <div className="text-muted">{ description }</div> }
      </div>
    </ListGroup.Item>
  )
}

export default SearchResultIntercomArticle
